var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm.upid,
      class: _vm.bemBlockMod({
        modal: _vm.context === _vm.CONTEXT_MODAL
      }),
      attrs: {
        id: "vueproduct",
        "data-get-content-asset": _vm.getContentAssetUrl
      }
    },
    [
      _vm.context === _vm.CONTEXT_ROUTER_VIEW &&
      !_vm.shouldHideExternalBackButton
        ? _c("BaseBackButton")
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "product-detail product-wrapper product-detail-vue",
          attrs: { "data-context": _vm.context, "data-pid": _vm.product.id }
        },
        [
          _c("BaseProductDataForSfra", { attrs: { product: _vm.product } }),
          _vm._v(" "),
          _c("meta", { attrs: { itemprop: "sku", content: _vm.product.id } }),
          _vm._v(" "),
          _c("meta", { attrs: { itemprop: "mpn", content: _vm.product.id } }),
          _vm._v(" "),
          _vm.product.longDescription
            ? _c("meta", {
                attrs: {
                  itemprop: "description",
                  content: _vm.product.longDescription
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("meta", { attrs: { itemprop: "brand", content: "BIMBA Y LOLA" } }),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "imagesContainer",
              class: _vm.bemElement(
                _vm.isBreakpointDesktop
                  ? "images-container"
                  : "carousel-container"
              )
            },
            [
              !_vm.hasImages
                ? _c("div", { class: _vm.bemElement("pre-placeholder") }, [
                    _c("span", { class: [_vm.bemElement("pic"), "img"] })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.productImageSets, function(imageSet, imageIndex) {
                return _c("BaseImage", {
                  key: imageIndex,
                  class: _vm.bemElement("pic"),
                  attrs: {
                    src: _vm.getDefaultImageUrlFromProductImageSet(imageSet),
                    alt: _vm.getDefaultImageAltFromProductImageSet(imageSet),
                    loading:
                      imageIndex < 1 || _vm.areCriticalImagesLoaded
                        ? "eager"
                        : null,
                    placeholder: _vm.getPlaceholderImageUrlFromProductImageSet(
                      imageSet
                    ),
                    sizes: _vm.imageAttributeSizes.PDP_GALLERY,
                    srcset: _vm.getSrcsetFromProductImageSet(imageSet)
                  },
                  on: {
                    "image-click": function(event) {
                      return _vm.handleProductImageClick(event, imageIndex)
                    },
                    load: function($event) {
                      return _vm.handleImageLoad(imageIndex)
                    }
                  }
                })
              }),
              _vm._v(" "),
              _vm.$windowWidth < 575 && _vm.hasImages
                ? _c("BaseCarousel", {
                    class: _vm.bemElement("carousel"),
                    attrs: { items: _vm.productImageSets },
                    on: {
                      "carousel-click": function(event, currentIndex) {
                        return _vm.handleProductImageClick(event, currentIndex)
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(slotProps) {
                            return [
                              _c("BaseImage", {
                                ref: "carouselItem" + slotProps.index,
                                class: slotProps.classname,
                                attrs: {
                                  src: _vm.getDefaultImageUrlFromProductImageSet(
                                    slotProps.item
                                  ),
                                  alt: _vm.getDefaultImageAltFromProductImageSet(
                                    slotProps.item
                                  ),
                                  "image-classes": _vm.bemElement("image"),
                                  loading:
                                    slotProps.index === 0 ||
                                    _vm.areCriticalImagesLoaded
                                      ? "eager"
                                      : null,
                                  placeholder: _vm.getPlaceholderImageUrlFromProductImageSet(
                                    slotProps.item
                                  ),
                                  sizes: _vm.imageAttributeSizes.PDP_GALLERY,
                                  srcset: _vm.getSrcsetFromProductImageSet(
                                    slotProps.item
                                  )
                                },
                                on: {
                                  load: function($event) {
                                    return _vm.handleImageLoad(slotProps.index)
                                  }
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2875319704
                    )
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { class: _vm.bemElement("text-container") }, [
            _c(
              "div",
              {
                ref: "infoContainer",
                class: _vm.bemElement("sticky-container")
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "interaction--loading-content",
                    class: { "interaction-active": !_vm.loading },
                    attrs: {
                      "data-interaction": "interaction--loading-content"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "loading-content" },
                      [_c("BaseSpinner", { attrs: { small: "", grey: "" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "loaded-content" },
                      [
                        _c(
                          "div",
                          { class: _vm.bemElement("sticky-child-container") },
                          [
                            _c(
                              "div",
                              { class: _vm.bemElement("title-wrapper") },
                              [
                                _c(
                                  "h1",
                                  {
                                    class: _vm.bemElement("title"),
                                    attrs: { itemprop: "name" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.product.productName) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.product.longDescription
                          ? _c("p", {
                              class: _vm.bemElement("description"),
                              domProps: {
                                innerHTML: _vm._s(_vm.product.longDescription)
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.individualProducts.length > 0
                          ? _c("BaseProductSlider", {
                              class: _vm.bemElement("products"),
                              attrs: {
                                products: _vm.individualProducts,
                                "tile-context": _vm.productSet
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                )
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.recommendedProducts.length > 0
        ? _c("BaseProductSlider", {
            class: _vm.bemElement("recommendations"),
            attrs: {
              heading: _vm.recommendationsHeading,
              products: _vm.recommendedProducts,
              "wrap-items": true,
              "tile-context": _vm.pdpRecommendedSlider,
              "hide-product-names": _vm.recommendationsDisplay.hideProductNames,
              "hide-prices": _vm.recommendationsDisplay.hidePrices,
              "hide-discount": _vm.recommendationsDisplay.hideDiscount,
              "hide-tags": _vm.recommendationsDisplay.hideTags,
              "is-recommendation-from-einstein":
                _vm.isRecommendationFromEinstein,
              "recommender-name": _vm.recommendationsRecommenderName
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("TheProductDetailsZoom", {
        class: {
          "is-visible": _vm.isZoomOpen
        },
        attrs: {
          "is-visible": _vm.isZoomOpen,
          images: _vm.productImageSets,
          loading: _vm.areGalleryImagesLoaded ? "eager" : null,
          "zoom-requirements": _vm.zoomRequirements
        },
        on: {
          "close-click": function($event) {
            return _vm.closeZoom(true)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }